import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getAuthClientList, getPlanAuth, showProgress } from '../../redux/actions/DealershipActions';
import PopupDropDown from '../common/PopupDropDown';
import Theme from '../ui/Theme';
import service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';

toast.configure();
const useStyles = makeStyles(() => ({
  popSubmitBtn: {
    padding: '0 70px',
    height: '42px',
    width: '145px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '42px',
    width: '130px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '15px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  popupMainContainer: {
    marginTop: '43px',
  },
}));
const ConfigureAuthPopup = (props) => {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const customStyles = {
    content: {
      height: '247',
      width: '500px',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  const authList = useSelector((state) => state.getAuthClientList.authClientList);
  const classes = useStyles();
  const planDetails = useSelector((state) => state.getPlanDetails.plandetails);
  /* For Multi Select */
  // const handleSelectedValue = (e) => {
  //   let value = e.target.value;
  //   let tempIdArr = [];
  //   let tempValArr = [];
  //   value.map((item) => {
  //     var result = authList.filter((obj) => {
  //       return obj.name === item;
  //     });
  //     tempIdArr.push(result[0].id);
  //     tempValArr.push(item);
  //     console.log([...tempValArr]);
  //   });
  //   setSelectedId([...tempIdArr]);
  //   setSelectedValue([...tempValArr]);
  // };
  /* For Multi Select */
  const handleSelectedValue = (e) => {
    const result = authList.filter((obj) => obj.name === e.target.value);
    setSelectedId(result[0].id);
    setSelectedValue(e.target.value);
  };
  const getSelectedAuth = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.PLAN_AUTHENTICATION.replace('PLAN_ID', planDetails.id))
      .then((response) => {
        setSelectedValue(response[0]);
        const id = authList?.filter((item) => item.name === response[0])[0].id;
        setSelectedId(id);
        dispatch(showProgress(false));
      })
      .catch(() => {
        dispatch(showProgress(false));
      });
  };
  const getClientList = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.AUTH_APP_AUTHENTICATION)
      .then((response) => {
        dispatch(getAuthClientList('add', response));
        dispatch(showProgress(false));
      })
      .catch(() => {
        dispatch(showProgress(false));
      });
  };
  useEffect(() => {
    getClientList();
  }, []);

  useEffect(() => {
    if (authList && authList.length > 0) {
      getSelectedAuth();
    }
  }, [authList]);
  const submit = async () => {
    dispatch(showProgress(true));
    const data = JSON.stringify({
      appAuthenticationsId: selectedId,
    });

    await service
      .post(apiEndpoints.PLAN_AUTHENTICATION.replace('PLAN_ID', planDetails.id), data)
      .then(() => {
        dispatch(getPlanAuth(selectedValue));
        dispatch(showProgress(false));
        notifySuccess('Configured Successfully');
        props.close();
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  return (
    <Modal isOpen onRequestClose={props.close} style={customStyles}>
      <Grid container direction="row">
        <Grid item xs={12}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            style={{ height: '38px' }}
          >
            <Grid item className={classes.popupHeading}>
              Configure Authentication
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid
        container
        direction="row"
        style={{ width: "491px" }}
        justifyContent="space-between"
      >
        <Grid item className={classes.popupSubHeading}>
          {"Does this plan need Authentication"}
        </Grid>
        <Grid item>
          <AntSwitch
            defaultChecked={enable}
            onClick={() => {}}
            onChange={setEnableVal}
            inputProps={{ "aria-label": "ant design" }}
          />
        </Grid>
      </Grid> */}

      <Grid container direction="row">
        <Grid item>
          <PopupDropDown
            name="auth"
            handleChange={handleSelectedValue}
            value={selectedValue}
            list={authList}
            height="45px"
            width="491px"
            marginBottom="24px"
          />
        </Grid>
      </Grid>

      <Grid container style={{ width: '491px' }} justifyContent="center" alignItems="center">
        <Button variant="contained" className={classes.popCancelBtn} onClick={props.close}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={submit}>
          Save
        </Button>
      </Grid>
    </Modal>
  );
};

export default ConfigureAuthPopup;
